export interface Console {
  loaded: boolean;
}

export enum CONSOLE {
  LOAD = "CONSOLE_LOAD",
}
